import React from 'react';
import { Button, Input } from '@uclaea/react-component-library';
import { useAddGuest } from './hooks/useAddGuest';
import './css/Modal.css';

interface AddGuestModalProps {
  eventId: string;
  onClose: () => void;
  onSuccess?: () => void;
}

const AddGuestModal: React.FC<AddGuestModalProps> = ({ eventId, onClose, onSuccess }) => {
  const {
    guestFirstName, setGuestFirstName,
    guestLastName, setGuestLastName,
    guestEmail, setGuestEmail,
    addGuestLoading, guestFeedback,
    handleAddGuest,
  } = useAddGuest(eventId, () => {
    onClose();
    onSuccess?.();
  });

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Add Guest Registration</h2>
        <form onSubmit={(e) => { void handleAddGuest(e); }}>
          <Input
            label="First Name"
            type="text"
            placeholder="First Name"
            value={guestFirstName}
            onChange={e => setGuestFirstName(e.target.value)}
            required
          />
          <Input
            label="Last Name"
            type="text"
            placeholder="Last Name"
            value={guestLastName}
            onChange={e => setGuestLastName(e.target.value)}
            required
          />
          <Input
            label="Email"
            type="email"
            placeholder="Email"
            value={guestEmail}
            onChange={e => setGuestEmail(e.target.value)}
            required
          />
          <br />
          <Button
            variant="primary"
            label={addGuestLoading ? 'Adding...' : 'Add Guest'}
            type="submit"
            disabled={addGuestLoading}
          />
          {guestFeedback && (
            <div className={`event-actions-feedback ${guestFeedback.includes('success') ? 'feedback--success' : 'feedback--error'}`}>
              {guestFeedback}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddGuestModal;
